import { color } from '@starrez/starrytheme';
import React from 'react';
import styled from 'styled-components';

export interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    onClick: () => void;
    ariaLabel: string;
    disabled?: boolean;
    title: string;
    variant?: 'small' | 'large';
    children: React.ReactNode;
}

export const Button = React.forwardRef<HTMLButtonElement, IButtonProps>(
    ({ children, onClick, disabled, variant = 'large', ariaLabel, title, ...props }, ref) => {
        const handleOnClick = () => {
            onClick();
        };

        return (
            <StyledButton
                {...props}
                ref={ref}
                aria-label={ariaLabel}
                title={title}
                isLarge={variant === 'large'}
                onClick={handleOnClick}
                disabled={disabled}
            >
                {children}
            </StyledButton>
        );
    }
);

const StyledButton = styled.button<{ isLarge: boolean }>`
    height: ${(props) => (props.isLarge ? '40px' : '32px')};
    width: ${(props) => (props.isLarge ? '40px' : '32px')};
    background-color: transparent;
    border-radius: 4px;
    color: ${color.Grey.G70};
    border: 2px solid transparent;
    cursor: pointer !important;
    display: grid;
    justify-content: center;
    align-items: center;

    > * {
        cursor: pointer !important;
    }

    :disabled > *,
    :disabled {
        cursor: not-allowed;
    }

    &[aria-pressed='true'],
    &:hover:not(:disabled) {
        background-color: ${color.Blue.B20};
        color: ${color.StarRezBrandColors.Blue60};
    }

    :focus {
        border: 2px solid ${color.Blue.B80};
        outline-offset: 0px;
    }

    &[disabled] {
        opacity: 0.4;
    }
`;
